export enum MyMenu {
  HOME = 'HOME',
  ZZIM_PRODUCT = 'ZZIM_PRODUCT',
  PRODUCT_REVIEW = 'PRODUCT_REVIEW',
  ZZIM_STORE = 'ZZIM_STORE',
  PRODUCT_QNA = 'PRODUCT_QNA',
  VIEWED_PRODUCT = 'VIEWED_PRODUCT',
  FREE_TRIAL = 'FREE_TRIAL',
  AITEMS = 'AITEMS',
  PREFERENCE_MALL = 'PREFERENCE_MALL',
}

export enum MySubMenu {
  WRITTEN_REVIEW = 'WRITTEN_REVIEW',
  WRITABLE_REVIEW = 'WRITABLE_REVIEW',
  SUB_ZZIM_STORE = 'SUB_ZZIM_STORE',
  TALKTALK = 'TALKTALK',
  STORE_FEED = 'STORE_FEED',
  MY_SIZE = 'MY_SIZE',
}

export interface MyMenuConfig {
  pcTitle?: string
  mobileTitle: string
  description?: string
  pcPath?: string
  mobilePath: string
  isMobileOnly: boolean
  subMenus?: MySubMenu[]
  nClickCode?: string
}

export interface MySubMenuConfig {
  pcTitle: string
  mobileTitle: string
  description?: string
  path?: string // 추후 pc, mobile 주소를 같게 해서 모든 페이지 리액트 전환된다면 path만 남겨둘 것임
  pcPath: string
  mobilePath: string
  isMobileOnly: boolean
  parentMenu?: MyMenu
  nClickCode?: string
}

type MyMenuConfigType = { [key in MyMenu]: MyMenuConfig }
type MySubMenuConfigType = { [key in MySubMenu]: MySubMenuConfig }

export const myMenuConfig: MyMenuConfigType = {
  HOME: {
    pcTitle: '쇼핑MY',
    mobileTitle: 'MY홈',
    pcPath: '/my/p/home.nhn',
    mobilePath: '/my/home.nhn',
    isMobileOnly: false,
  },
  ZZIM_PRODUCT: {
    pcTitle: '찜한 상품',
    mobileTitle: '찜한 상품',
    description: '최근 1년간의 찜한 상품 내역이 제공됩니다.',
    pcPath: '/my/p/zzim/index.nhn',
    mobilePath: '/my/zzim/index.nhn',
    isMobileOnly: false,
  },
  PRODUCT_REVIEW: {
    pcTitle: '상품리뷰',
    mobileTitle: '상품리뷰',
    pcPath: '/my/writable-reviews',
    mobilePath: '/my/writable-reviews',
    isMobileOnly: false,
    subMenus: [MySubMenu.WRITABLE_REVIEW, MySubMenu.WRITTEN_REVIEW],
    nClickCode: 'review',
  },
  ZZIM_STORE: {
    pcTitle: '관심 스토어',
    mobileTitle: '관심 스토어',
    pcPath: '/my/p/store/list.nhn',
    mobilePath: '/my/feeds.nhn',
    isMobileOnly: false,
    subMenus: [MySubMenu.SUB_ZZIM_STORE, MySubMenu.TALKTALK, MySubMenu.STORE_FEED],
  },
  PRODUCT_QNA: {
    pcTitle: '상품 Q&A',
    mobileTitle: '상품 Q&A',
    pcPath: '/my/p/qna/index.nhn',
    mobilePath: '/my/qna/index.nhn',
    isMobileOnly: false,
  },
  VIEWED_PRODUCT: {
    pcTitle: '최근 본 상품',
    mobileTitle: '최근 본 상품',
    pcPath: '/my/p/recent/index.nhn',
    mobilePath: '/my/viewproduct/index.nhn',
    isMobileOnly: false,
  },
  FREE_TRIAL: {
    pcTitle: '무료체험',
    mobileTitle: '무료체험',
    pcPath: '/my/p/experience/index.nhn',
    mobilePath: '/my/experience/index.nhn',
    isMobileOnly: false,
  },
  AITEMS: {
    mobileTitle: 'AiTEMS 추천',
    mobilePath: '/my/AiTEMS/index.nhn',
    isMobileOnly: true,
  },
  PREFERENCE_MALL: {
    mobileTitle: '나의 선호몰',
    pcPath: '/my/preference-mall',
    mobilePath: '/my/preference-mall',
    isMobileOnly: true,
  },
}

export const mySubMenuConfig: MySubMenuConfigType = {
  SUB_ZZIM_STORE: {
    pcTitle: '관심 스토어',
    mobileTitle: '관심 스토어',
    pcPath: '/my/p/store/list.nhn',
    mobilePath: '/my/feeds.nhn',
    isMobileOnly: false,
    parentMenu: MyMenu.ZZIM_STORE,
  },
  TALKTALK: {
    pcTitle: '톡톡친구',
    mobileTitle: '톡톡친구',
    pcPath: '/my/p/talk/list.nhn',
    mobilePath: '/my/talk/list.nhn',
    isMobileOnly: false,
    parentMenu: MyMenu.ZZIM_STORE,
  },
  STORE_FEED: {
    pcTitle: '스토어 소식',
    mobileTitle: '스토어 소식',
    pcPath: '/my/p/feeds.nhn',
    mobilePath: '/my/feeds.nhn',
    isMobileOnly: false,
    parentMenu: MyMenu.ZZIM_STORE,
  },
  WRITABLE_REVIEW: {
    pcTitle: '작성 가능한 리뷰',
    mobileTitle: '작성 가능한 리뷰',
    path: '/my/writable-reviews',
    pcPath: '/my/writable-reviews',
    mobilePath: '/my/writable-reviews',
    isMobileOnly: false,
    parentMenu: MyMenu.PRODUCT_REVIEW,
    nClickCode: 'prv',
  },
  WRITTEN_REVIEW: {
    pcTitle: '내가 작성한 리뷰',
    mobileTitle: '내가 작성한 리뷰',
    path: '/my/written-reviews',
    pcPath: '/my/written-reviews',
    mobilePath: '/my/written-reviews',
    isMobileOnly: false,
    parentMenu: MyMenu.PRODUCT_REVIEW,
    nClickCode: 'mrv',
  },
  MY_SIZE: {
    pcTitle: '네이버쇼핑',
    mobileTitle: '네이버쇼핑',
    isMobileOnly: false,
    pcPath: '/my/my-sizes',
    mobilePath: '/my/my-sizes',
  },
}

export const isMyService = (path: string): boolean => {
  return (path && path.startsWith('/my')) || path.indexOf('/my') > -1
}

export const getMySubMenuByPath = (pathName: string): MySubMenu => {
  for (const mySubMenuConfigKey in mySubMenuConfig) {
    // 추후 pcPath, mobilePath 삭제하고 path만 남길 때 같이 수정
    if (mySubMenuConfig[mySubMenuConfigKey].pcPath === pathName) return MySubMenu[mySubMenuConfigKey]
  }
}

export const getMyMenuByPath = (pathName: string): MyMenu => {
  for (const myMenuConfigKey in myMenuConfig) {
    // 추후 pcPath, mobilePath 삭제하고 path만 남길 때 같이 수정
    if (myMenuConfig[myMenuConfigKey].pcPath === pathName) return MyMenu[myMenuConfigKey]
  }
}
